export default __webpack_public_path__ + "static/media/nav_detail_img_14.2f4eb6de.jpg";